export default [
  {
    title: 'Sobre a GERU',
    text: `
      A Geru é uma fintech que atua como plataforma de empréstimos online criada em 2015. A empresa alega querer mudar o mercado de crédito brasileiro por oferecer taxas menores e personalizadas, conforme o perfil do consumidor.
      <br />
      O empréstimo Geru é 100% online, desde a simulação até a contratação. A empresa tem a proposta de fazer análises de créditos rápida e, em caso de aprovação, o dinheiro é liberado em até 1 dia útil.
    `,
  },
  {
    title: 'O que é empréstimo sem garantia?',
    text: `
      A principal característica do empréstimo pessoal sem garantia é não exigir que você coloque seus bens (ou seu salário) no contrato de aquisição como forma de assegurar o pagamento.

      Caso você fique inadimplente, a instituição financeira tomará as medidas cabíveis, como negativação do CPF e tentativas de renegociação.

      Mas, como o empréstimo não tem garantia, as taxas geralmente são mais altas em relação ao empréstimo com garantia (quando você inclui seus bens para assegurar o pagamento).

      De maneira geral, ainda apresenta taxas de juros mais baixas e prazos maiores de pagamento em relação a outras modalidades de crédito, como cartão de crédito e cheque especial, por exemplo.
    `,
  },
  {
    title: 'Quais são as etapas de solicitação da oferta pré-aprovada?',
    text: `
      É super simples!
      <br />
      <ol>
        <li>Após clicar em “Solicitar oferta”</li>
        <li>Clique em “continuar”.</li>
        <li>Depois disso, você será direcionado (a) para o site da Geru para dar continuidade.</li>
      </ol>    
    `,
  },
  {
    title: 'O empréstimo Geru é confiável?',
    text: `
      Sim, a Geru é confiável. A empresa está registrada no Banco Central e atende à regulamentação para operações de empréstimo.
      <br />
      Em relação à opinião dos consumidores, a nota da Geru no Reclame Aqui é 7.9, considerada boa. Ao todo, 100% das reclamações foram respondidas, com um índice de solução de 83,9%. Do total de pessoas que registraram uma ocorrência, 61,7% afirmaram que voltariam a fazer negócio com a instituição.
    `,
  },
  {
    title: 'Posso alterar o valor das minhas parcelas?',
    text: `Por enquanto ainda não é possível alterar o valor das parcelas. O que você já pode fazer hoje em dia é antecipar suas parcelas e ganhar desconto nos juros.`,
  },
  {
    title: 'Posso alterar a minha taxa de juros?',
    text: `Não. A taxa de juros do seu crédito é calculada previamente, com base em suas informações financeiras, e não pode ser alterada após a contratação. O que você pode é ganhar um desconto nessa taxa caso antecipe o pagamento das parcelas.`,
  },
  {
    title: 'Preciso enviar algum documento?',
    text: `
      Pode ser que ao longo do seu pedido, a Geru precise de algum documento para validar sua identidade. Mas o envio é simples: basta tirar uma foto frente e verso do seu RG, CNH ou Registro Militar.
      <br />
      Se você tiver CNH digital, é só tirar uma foto do QR Code e outra do documento aberto.    
    `,
  },
  {
    title: 'Quais são os bancos e tipos de conta corrente aceitos?',
    text: `
      Antes de mais nada, é muito importante que a titularidade da conta seja sua e que você use essa conta com frequência, porque é ali que a Geru vai depositar seu crédito caso ele seja aprovado.
      Agora, pra saber se aceita seu banco e seu tipo de conta corrente, é só checar os itens a seguir:    
      <br />
      <ul>
        <li>A sua conta precisa ser conta corrente individual e de pessoa física;</li>
        <li>Só aceitam conta poupança da Caixa Econômica Federal;</li>
        <li>No momento, não aceitam Conta Fácil da Caixa Econômica Federal (operação 23) e conta ITI do Itaú;</li>
        <li>Mas a Geru aceita qualquer um desses bancos: Itaú, Santander, Bradesco, Banco do Brasil, Caixa Econômica Federal, Banrisul, Banco Original, Nubank, Sicredi, Banco do Nordeste do Brasil, Banestes, Banco do Estado do Pará, Banco de Brasília, Agibank, Banco Sofisa e Banco Votorantim.</li>
      </ul>
    `,
  },
  {
    title: 'Por que preciso conectar minha conta bancária?',
    text: `
      A conexão bancária é uma etapa muito importante pra que a Geru conheça melhor o seu perfil financeiro e te oferecer um crédito justo. Sabemos que essa conexão pode ser uma novidade pra você, mas não se preocupe, pois ela só permite que o sistema visualize o extrato de gastos, rotativo e cheque especial da sua conta bancária. Além disso, os seus dados são criptografados e não ficam salvos no sistema.
      <br />
      Pra realizar a conexão bancária, a senha eletrônica que é solicitada é a mesma que você usa pra ter acesso ao app ou site do seu banco.
    `,
  },
  {
    title: 'Faz empréstimo para negativado?',
    text: `Negativados têm chances de aprovação menores. Isso significa que negativados podem, sim, solicitar o empréstimo, mas dependem do retorno da análise de crédito para conseguir a liberação.`,
  },
  {
    title: 'Quanto tempo demora pro meu dinheiro cair na conta?',
    text: `Depois da finalização do pedido, se tudo estiver estiver ok, o dinheiro cai na sua conta em até 1 dia útil. Mas fique de olho no seu e-mail, pois se aparecer alguma pendência a Geru irá te avisar por lá.`,
  },
  {
    title: 'Quais as formas de pagamento?',
    text: `No momento só é aceito pagamento via boleto.`,
  },
  {
    title: 'Como recebo os boletos para pagamento?',
    text: `
      Todos os meses a Geru envia  um e-mail de lembrete junto com o link para baixar o boleto. Você recebe esse e-mail duas vezes: uma perto da data de vencimento e outra no próprio dia em que vence a parcela.
      <br />
      Se você preferir, também é possível baixar ou copiar a linha digitável do boleto lá na sua conta Geru. É só fazer o login que você já vai saber qual a parcela que falta pagar.
    `,
  },
]
